import { Filter } from '@elderbyte/ngx-starter'

export class PackageFilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private _orderReferenceNumber: string
  private _storageGroupIds: string[]
  private _storagePath: string
  private _storagePathDeepMatch: boolean

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static storageGroupIds(...storageGroupIds: string[]): Filter {
    return this.start()
      .storageGroupIds(...storageGroupIds)
      .build()[0]
  }

  public static orderReferenceNumber(orderReferenceNumber: string): Filter {
    return this.start().orderReferenceNumber(orderReferenceNumber).build()[0]
  }

  public static storagePath(storagePath: string, deepSearch: boolean): Filter[] {
    return this.start().storagePath(storagePath, deepSearch).build()
  }

  public static start(): PackageFilterBuilder {
    return new PackageFilterBuilder()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public orderReferenceNumber(orderReferenceNumber: string): PackageFilterBuilder {
    this._orderReferenceNumber = orderReferenceNumber
    return this
  }

  public storageGroupIds(...storageGroupIds: string[]): PackageFilterBuilder {
    this._storageGroupIds = storageGroupIds
    return this
  }

  public storagePath(storagePath: string, deepSearch: boolean): PackageFilterBuilder {
    this._storagePath = storagePath
    this._storagePathDeepMatch = deepSearch
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []

    if (this._orderReferenceNumber) {
      filters.push(new Filter('orderReferenceNumber', this._orderReferenceNumber))
    }

    if (this._storageGroupIds) {
      filters.push(new Filter('storageGroupIds', this._storageGroupIds))
    }

    if (this._storagePath) {
      filters.push(new Filter('storagePath', this._storagePath))
    }

    if (this._storagePathDeepMatch != null) {
      filters.push(new Filter('storagePathDeepMatch', String(this._storagePathDeepMatch)))
    }

    return filters
  }
}
